import { css } from 'styled-components';

export const paragraphStyle = css`
  display: block;
  font-family: ${props => props.theme.fonts.fontfaceLight};
  line-height: 1em;
  margin: 0;
  font-size: ${props => props.theme.fonts.sizeBase};
  line-height: 18px;
  color: ${props => props.theme.colors.primary};

  ${props =>
    props.danger &&
    css`
      color: ${props => props.theme.colors.danger};
    `} 

  ${props =>
    props.blockText &&
    css`
      font-family: ${props => props.theme.fonts.fontfaceBeta};
      padding: 2rem 1rem;
      color: ${props => props.theme.colors.primary};
      line-height: 1.3;
    `}
  
  ${props =>
    props.textcenter &&
    css`
      text-align: center;
    `}
  
  ${props =>
    props.inverted &&
    css`
      color: ${props => props.theme.colors.white};

      a {
        color: ${props => props.theme.colors.gray};
      }
    `}
  
  ${props =>
    props.italic &&
    css`
      font-style: italic;
    `}
  
  ${props =>
    props.upper &&
    css`
      text-transform: uppercase;
    `}
  
  ${props =>
    props.bold &&
    css`
      font-family: ${props => props.theme.fonts.fontfaceBold};
    `}
  
  ${props =>
    props.small &&
    css`
      font-size: ${props => props.theme.fonts.sizeSmall};
    `} 
  
  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
  }

  b {
    font-family: ${props => props.theme.fonts.fontfaceBold};
  }
`;

export const H2Style = css`
display: inline-block;
font-family: ${props => props.theme.fonts.fontfaceExtraLight};
font-size: ${props => props.theme.fonts.sizeH2};
/* letter-spacing: -0.05rem; */
line-height: 1.1;
margin: 0;
color: ${props => props.theme.colors.primary};
text-decoration: underline;
/* border-bottom: 4px solid ${props => props.theme.colors.primary}; */

${props =>
  props.upper &&
  css`
    text-transform: uppercase;
  `} 
${props =>
  props.textcenter &&
  css`
    text-align: center;
  `} 
${props =>
  props.textleft &&
  css`
    text-align: left;
  `} 
${props =>
  props.inverted &&
  css`
    color: ${props => props.theme.colors.white};
  `} 
${props =>
  props.highlighted &&
  css`
    color: ${props => props.theme.colors.primary};
  `};

${props =>
  props.block &&
  css`
    display: block;
  `} 
`;



// WEBPACK FOOTER //
// ./src/components/P/textStyle.js